<template>
  <div class="before-regist">
    <div class="txt-wrap">
      <h1 class="app-tit">
        {{
          t('register_and_change_payment_card', {
            cardType: props.currentTab === 'TOSS' ? t('ss_label_card_korean') : t('card_foreign_some_korean'),
          })
        }}
      </h1>
      <span class="sub-txt">
        {{
          t('current_payment_method', {
            cardType: props.currentTab === 'TOSS' ? t('card_foreign_some_korean') : t('ss_label_card_korean'),
          })
        }}
        <br />
        {{
          t('register_card_required', {
            cardType: props.currentTab === 'TOSS' ? t('ss_label_card_korean') : t('card_foreign_some_korean'),
          })
        }}
      </span>
    </div>

    <button type="button" class="card-add-btn" @click="handleCardAdd">
      <img :src="getAssetImageUrl('common/icons/add-icon.svg')" alt="" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { useBrandPay } from '@/composables/domains/self-service/useBrandPay';
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

const props = withDefaults(
  defineProps<{
    currentTab?: string;
  }>(),
  {}
);
const emit = defineEmits(['add-card', 'complete-card-add']);

const { t } = useI18n();

const { addPaymentMethod } = useBrandPay();

const handleCardAdd = () => {
  switch (props.currentTab) {
    case 'TOSS':
      addPaymentMethod(() => emit('complete-card-add'));
      break;
    case 'STRIPE':
      emit('add-card');
      break;
  }
};
</script>

<style scoped lang="scss">
.before-regist {
  text-align: center;
  .txt-wrap {
    padding: 2rem 0 1rem;
    .sub-txt {
      font-size: $font-size-psmall;
      color: $color-gray-200;
      line-height: 130%;
    }
  }
  .card-add-btn {
    width: 252px;
    aspect-ratio: 9 / 5;
    border-radius: $size-s;
    border: 1px dotted $color-gray-60;
    background: $gray10;
  }
}
</style>
